<script lang="ts" setup>
import { provide, ref } from "vue";
const hasFiltersSelected = ref(false);

const setHasFilterSelected = (hasSelected: boolean) => {
  hasFiltersSelected.value = hasSelected;
};

provide("TableFilter", {
  setHasFilterSelected,
});
</script>
<template>
  <div class="dropdown position-relative">
    <div
      v-if="hasFiltersSelected"
      class="filter-badge position-absolute bg-primary rounded-circle"
    ></div>
    <button
      class="btn btn-link text-body-secondary dropdown-toggle d-flex"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <i class="fas fa-sliders-h fs-3"></i>
    </button>
    <div class="dropdown-menu p-4">
      <slot></slot> <!-- aqui vai o component do filtro em si -->
    </div>
  </div>
</template>

<style lang="css" scoped>
.dropdown-toggle::after {
  content: "";
}
.dropdown-menu {
  min-width: 280px;
}
.filter-badge {
  width: 10px;
  height: 10px;
  background-color: red;
  position: absolute;
  right: 8px;
  top: 5px;
}
</style>
